import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSnowflakeComponent } from './simple-icons-snowflake.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSnowflakeComponent ],
    exports:      [ SimpleIconsSnowflakeComponent ],
    bootstrap:    []
})
export class SimpleIconsSnowflakeModule {}
